import { withTranslate } from '@i18n/utils'
import VehicleFormModal from '@components/VehicleFormModal'
import { vehiclesSelector } from '@booking/selectors'

import { VehicleTabs } from '@components/VehicleTabs'
import ErrorMessage from '@components/ErrorMessage'

import { purchaseDataSelector } from 'subscription-flow/canada/selectors'
import { setPurchaseData } from 'subscription-flow/canada/actions'

const VehiclesSection = ({ purchaseData, setPurchaseData, userVehicles, translate: t }) => {
    const { vehicles: selectedVehicles } = purchaseData

    const setSelectedVehicles = vehicles => {
        setPurchaseData({
            ...purchaseData,
            vehicles,
        })
    }

    return (
        <div className="mt-5">
            <h3 className="mb-5 font-weight-bold">
                <T>subscription.purchase.label.vehicles</T>
            </h3>
            {selectedVehicles.length === 0 && (
                <ErrorMessage messages={[t('purchase.flow.vehicles.add.vehicle.warning')]} type="text" />
            )}
            <div className="d-flex flex-column">
                <VehicleTabs
                    setSelectedVehicles={setSelectedVehicles}
                    vehicles={selectedVehicles}
                    userVehicles={userVehicles}
                    maxVehicles={userVehicles.length}
                    isVehiclesListOpen
                    canAddPlate={false}
                />

                <VehicleFormModal />
            </div>
        </div>
    )
}

export default compose(
    withTranslate,
    connect(
        createStructuredSelector({
            userVehicles: vehiclesSelector,
            purchaseData: purchaseDataSelector,
        }),
        { setPurchaseData }
    )
)(VehiclesSection)
